// Phoebe's identity chip beside assistant messages: the flower mark on a
// soft purple rounded square, per the gallery's assistant-avatar spec.
import { type ReactNode } from 'react';

import { FlowerMark } from '@apps/web/features/phoebe_chat_v3/ui/primitives/flower_mark';
import { cn } from '@apps/web/lib/utils';

export type AssistantAvatarProps = Readonly<{
    readonly className?: string;
}>;

export function AssistantAvatar({
    className,
}: AssistantAvatarProps): ReactNode {
    return (
        <span
            aria-hidden="true"
            data-testid="assistant-avatar"
            className={cn(
                'flex size-7 shrink-0 items-center justify-center',
                'rounded-md bg-agent-action-soft p-1.5 text-agent-action dark:text-violet-300',
                className,
            )}
        >
            <FlowerMark className="size-full" />
        </span>
    );
}
